import { useEffect, useState } from "react";

export function useSyncCoworkerStore() {
  const [store, setStore] = useState<CoworkerProfileStore | undefined>(
    undefined
  );

  const updateCoworkerStore = (event: any) => {
    if (event?.detail) {
      setStore({
        ...event.detail,
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setStore({
        ...((window?.salja?.coworkerprofile?.data?.store as any) ?? {}),
      });
      window?.salja?.coworkerprofile?.events?.store?.subscribe(
        updateCoworkerStore
      );
    }, 1500);
    return () => {
      clearTimeout(timer);
      window?.salja?.coworkerprofile?.events?.store?.unsubscribe(
        updateCoworkerStore
      );
    };
  }, []);

  return store;
}
